import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { PromoFluentIds } from "byzantine/src/l10n/SettingFluentIds";
import type { PromotionCardProps } from "./types";
import BorderCard from "../../../components/BorderCard";

const BorderedPromotionCard = ({ promotion }: PromotionCardProps) => {
  const { l10n } = useLocalization();
  const promoIndex = promotion.promo_index || 0;

  const fluentIds = new PromoFluentIds(promoIndex);
  const translatedPromotion = {
    title: l10n.getString(fluentIds.getTitle(), null, promotion.title),
    description: l10n.getString(
      fluentIds.getDescription(),
      null,
      promotion.description
    ),
    action_text: l10n.getString(
      fluentIds.getActionText(),
      null,
      promotion.action_text || "Learn more"
    )
  };

  return (
    <BorderCard title={translatedPromotion.title}>
      <div className="dashboard-section-container">
        <div className="dashboard-item-border-box" data-testid="promotion-item">
          <div className="dashboard-item-description">
            {translatedPromotion.description}
          </div>
          <div className="margin--top--s">
            <Button
              as="a"
              href={promotion.url}
              kind="plain"
              label={translatedPromotion.action_text}
              testId="promotion-action"
              rel="noreferrer"
              target="_blank"
            />
          </div>
        </div>
      </div>
    </BorderCard>
  );
};

export default BorderedPromotionCard;
